module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-visible-off-7ac9484bc9da681bda503a3db490469d.png";